import { PageId } from 'constants/pages'
import { PaymentSystem } from 'nove8/constants/root-constants'
import { routeHistory } from 'route-history'

export const PURCHASE_REDIRECT_SEARCH_PARAMS = {
  purchaseId: 'purchaseId',
  purchasePageId: 'purchasePageId',
  paymentSystem: 'paymentSystem',
  paymentMethod: 'paymentMethod',
} as const

type TPurchaseRedirectData = {
  purchaseId: string
  purchasePageId: PageId | null
  paymentSystem: PaymentSystem
  paymentMethod: string
}

export const getPurchaseRedirectUrl = ({
  purchaseId,
  purchasePageId,
  paymentSystem,
  paymentMethod,
}: TPurchaseRedirectData): string => {
  const url = new URL(window.location.href)

  url.searchParams.set(PURCHASE_REDIRECT_SEARCH_PARAMS.purchaseId, purchaseId)
  url.searchParams.set(
    PURCHASE_REDIRECT_SEARCH_PARAMS.purchasePageId,
    purchasePageId || '',
  )
  url.searchParams.set(
    PURCHASE_REDIRECT_SEARCH_PARAMS.paymentSystem,
    paymentSystem,
  )

  url.searchParams.set(
    PURCHASE_REDIRECT_SEARCH_PARAMS.paymentMethod,
    paymentMethod,
  )

  return url.toString()
}

export const removePurchaseRedirectSearchParams = (): void => {
  const url = new URL(window.location.href)

  Object.values(PURCHASE_REDIRECT_SEARCH_PARAMS).forEach((searchParam) => {
    url.searchParams.delete(searchParam)
  })

  // replace through routeHistory so react-router picks up the change,
  // otherwise useUpdateUrlWithRequiredSearchParams rebuilds the url from a
  // stale location and puts the params back
  routeHistory.replace({
    pathname: url.pathname,
    search: url.search,
    hash: url.hash,
  })
}
